<div class="wishlist-content" dir="rtl">

  <div class="wishlist-head">
    <h5 class="wishlist-title">
      <i class="mdi mdi-heart-outline"></i>
      {{ this.translate.instant('sale4you.label.MyWishlist') }}
    </h5>
  </div>

  <div class="wishlist-body">
    <app-item-in-wishlist></app-item-in-wishlist>
  </div>

</div>
